"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataMapLocalizationProvider = DataMapLocalizationProvider;
exports.useLocalization = useLocalization;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _actions = require("../../redux/dashboard/actions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DataMapLocalizationContext = /*#__PURE__*/(0, _react.createContext)();
function DataMapLocalizationProvider(props) {
  // Local storage key
  var DATA_MAP_LOCALIZATION_STORE = "dataMapLocalizationStore";

  // Scope constant
  var SCOPE_IDENTIFIRE = {
    USERS: {
      DATASCOPEID: 1
    },
    RECORDS: {
      DATASCOPEID: 2
    },
    FUND_DETAILS: {
      DATASCOPEID: 3
    },
    FY_PERFORMANCE: {
      DATASCOPEID: 4
    },
    FY_DONORS: {
      DATASCOPEID: 5
    },
    FY_IMPACT: {
      DATASCOPEID: 6
    }
  };

  // Scope store constant
  var SCOPE_STORE_OBJECT = [{
    fkDataScopeId: SCOPE_IDENTIFIRE.USERS.DATASCOPEID,
    dataScopeName: "User",
    storeName: "User"
  }, {
    fkDataScopeId: SCOPE_IDENTIFIRE.RECORDS.DATASCOPEID,
    dataScopeName: "Record",
    storeName: "Record"
  }, {
    fkDataScopeId: SCOPE_IDENTIFIRE.FUND_DETAILS.DATASCOPEID,
    dataScopeName: "Fund",
    storeName: "Fund"
  }, {
    fkDataScopeId: SCOPE_IDENTIFIRE.FY_PERFORMANCE.DATASCOPEID,
    dataScopeName: "Fund Performance",
    storeName: "Fund_Performance"
  }, {
    fkDataScopeId: SCOPE_IDENTIFIRE.FY_DONORS.DATASCOPEID,
    dataScopeName: "Fund Donors",
    storeName: "Fund_Donors"
  }, {
    fkDataScopeId: SCOPE_IDENTIFIRE.FY_IMPACT.DATASCOPEID,
    dataScopeName: "Fund Impact",
    storeName: "Fund_Impact"
  }];

  // Mapping of survey field name with dom field name
  var dataMapFieldMappingDom = function dataMapFieldMappingDom(surveyDataBackendList) {
    surveyDataBackendList === null || surveyDataBackendList === void 0 ? void 0 : surveyDataBackendList.forEach(function (item) {
      item.domFieldLabel = item.colFieldName;
      // item.domFieldLabel = surveyDataMapping[
      //   item.dataScopeName.replaceAll(" ", "_")
      // ].find(
      //   (f) => f.colFieldName === item.colFieldName
      // )?.domFieldLabel;
    });
  };

  // Create store object and store it in local storage
  var surveyStoreInit = function surveyStoreInit(surveyDataBackendList) {
    dataMapFieldMappingDom(surveyDataBackendList);
    var getStoreData_ = localStorage.getItem(DATA_MAP_LOCALIZATION_STORE);
    var storeObj = getStoreData_ ? JSON.parse(getStoreData_) : {};
    if ((surveyDataBackendList === null || surveyDataBackendList === void 0 ? void 0 : surveyDataBackendList.length) > 0) {
      var storeScopeName = SCOPE_STORE_OBJECT.find(function (item) {
        return item.fkDataScopeId === surveyDataBackendList[0].fkDataScopeId;
      }).storeName;
      storeObj[storeScopeName] = {};
      surveyDataBackendList === null || surveyDataBackendList === void 0 ? void 0 : surveyDataBackendList.forEach(function (item) {
        var _colNamingFields_$cus;
        var colNamingFields_ = (item === null || item === void 0 ? void 0 : item.colNamingFields) && JSON.parse(item === null || item === void 0 ? void 0 : item.colNamingFields);
        storeObj[storeScopeName][item.colFieldName] = {
          default: item === null || item === void 0 ? void 0 : item.domFieldLabel,
          customLabel: (colNamingFields_ === null || colNamingFields_ === void 0 ? void 0 : (_colNamingFields_$cus = colNamingFields_.customLabel) === null || _colNamingFields_$cus === void 0 ? void 0 : _colNamingFields_$cus.value) || (item === null || item === void 0 ? void 0 : item.domFieldLabel)
        };
      });
      localStorage.setItem(DATA_MAP_LOCALIZATION_STORE, JSON.stringify(storeObj));
    }
  };

  // Update store object and store it in local storage
  var surveyStoreUpdate = function surveyStoreUpdate(data) {
    var _colNamingFields_$cus2;
    var storeObj = JSON.parse(localStorage.getItem(DATA_MAP_LOCALIZATION_STORE)) || {};
    var scopeObj = storeObj[SCOPE_STORE_OBJECT.find(function (item) {
      return item.fkDataScopeId === (data === null || data === void 0 ? void 0 : data.fkDataScopeId);
    }).storeName];
    var fieldObj = scopeObj[data === null || data === void 0 ? void 0 : data.colFieldName];
    var colNamingFields_ = (data === null || data === void 0 ? void 0 : data.colNamingFields) && JSON.parse(data === null || data === void 0 ? void 0 : data.colNamingFields);
    fieldObj.customLabel = colNamingFields_ === null || colNamingFields_ === void 0 ? void 0 : (_colNamingFields_$cus2 = colNamingFields_.customLabel) === null || _colNamingFields_$cus2 === void 0 ? void 0 : _colNamingFields_$cus2.value;
    localStorage.setItem(DATA_MAP_LOCALIZATION_STORE, JSON.stringify(storeObj));
  };

  // Clear store object from local storage
  var surveyStoreClear = function surveyStoreClear() {
    localStorage.removeItem(DATA_MAP_LOCALIZATION_STORE);
  };
  var surveyStoreSettingsSave = function surveyStoreSettingsSave(data) {
    localStorage.setItem(DATA_MAP_LOCALIZATION_STORE + "Settings", JSON.stringify(data));
  };
  var surveyStoreSettingsFetch = function surveyStoreSettingsFetch() {
    return JSON.parse(localStorage.getItem(DATA_MAP_LOCALIZATION_STORE + "Settings"));
  };

  // Render store object in UI
  var renderCustomLabel = function renderCustomLabel(dataMapFieldName, fkDataScopeId, domFieldLabel) {
    var _scopeObj$dataMapFiel, _scopeObj$dataMapFiel2;
    var storeObj = JSON.parse(localStorage.getItem(DATA_MAP_LOCALIZATION_STORE)) || {};
    var scopeObj = storeObj[SCOPE_STORE_OBJECT.find(function (item) {
      return item.fkDataScopeId === fkDataScopeId;
    }).storeName];
    var label = "";
    if (surveyStoreSettingsFetch() === true && scopeObj && (_scopeObj$dataMapFiel = scopeObj[dataMapFieldName]) !== null && _scopeObj$dataMapFiel !== void 0 && _scopeObj$dataMapFiel.customLabel) {
      label = scopeObj[dataMapFieldName].customLabel;
    } else if (domFieldLabel) {
      label = domFieldLabel;
    } else if (scopeObj && (_scopeObj$dataMapFiel2 = scopeObj[dataMapFieldName]) !== null && _scopeObj$dataMapFiel2 !== void 0 && _scopeObj$dataMapFiel2.default) {
      label = scopeObj[dataMapFieldName].default;
    }
    return label;
  };
  var getStoreData = localStorage.getItem(DATA_MAP_LOCALIZATION_STORE);
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      var _state$auth, _state$organizationIn, _state$dataMap, _state$dataMap$fieldU, _state$dataMap2, _state$dataMap2$field, _state$dataMap3, _state$dataMap3$field, _state$dataMap4, _state$dataMap4$field, _state$dataMap5, _state$dataMap5$field, _state$dataMap6, _state$dataMap6$field;
      return {
        me: state === null || state === void 0 ? void 0 : (_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : _state$auth.me,
        orgInfo: state === null || state === void 0 ? void 0 : (_state$organizationIn = state.organizationInfo) === null || _state$organizationIn === void 0 ? void 0 : _state$organizationIn.fetch,
        fieldUser: state === null || state === void 0 ? void 0 : (_state$dataMap = state.dataMap) === null || _state$dataMap === void 0 ? void 0 : (_state$dataMap$fieldU = _state$dataMap.fieldUser) === null || _state$dataMap$fieldU === void 0 ? void 0 : _state$dataMap$fieldU.data,
        fieldRecord: state === null || state === void 0 ? void 0 : (_state$dataMap2 = state.dataMap) === null || _state$dataMap2 === void 0 ? void 0 : (_state$dataMap2$field = _state$dataMap2.fieldRecord) === null || _state$dataMap2$field === void 0 ? void 0 : _state$dataMap2$field.data,
        fieldFund: state === null || state === void 0 ? void 0 : (_state$dataMap3 = state.dataMap) === null || _state$dataMap3 === void 0 ? void 0 : (_state$dataMap3$field = _state$dataMap3.fieldFund) === null || _state$dataMap3$field === void 0 ? void 0 : _state$dataMap3$field.data,
        fieldPerformance: state === null || state === void 0 ? void 0 : (_state$dataMap4 = state.dataMap) === null || _state$dataMap4 === void 0 ? void 0 : (_state$dataMap4$field = _state$dataMap4.fieldPerformance) === null || _state$dataMap4$field === void 0 ? void 0 : _state$dataMap4$field.data,
        fieldDonor: state === null || state === void 0 ? void 0 : (_state$dataMap5 = state.dataMap) === null || _state$dataMap5 === void 0 ? void 0 : (_state$dataMap5$field = _state$dataMap5.fieldDonor) === null || _state$dataMap5$field === void 0 ? void 0 : _state$dataMap5$field.data,
        fieldImpact: state === null || state === void 0 ? void 0 : (_state$dataMap6 = state.dataMap) === null || _state$dataMap6 === void 0 ? void 0 : (_state$dataMap6$field = _state$dataMap6.fieldImpact) === null || _state$dataMap6$field === void 0 ? void 0 : _state$dataMap6$field.data
      };
    }),
    me = _useSelector.me,
    orgInfo = _useSelector.orgInfo,
    fieldUser = _useSelector.fieldUser,
    fieldRecord = _useSelector.fieldRecord,
    fieldFund = _useSelector.fieldFund,
    fieldPerformance = _useSelector.fieldPerformance,
    fieldDonor = _useSelector.fieldDonor,
    fieldImpact = _useSelector.fieldImpact;
  (0, _react.useEffect)(function () {
    var _me$role;
    if (getStoreData === null && me !== false && (me === null || me === void 0 ? void 0 : (_me$role = me.role) === null || _me$role === void 0 ? void 0 : _me$role.name) !== "PLATFORM ADMIN") {
      dispatch((0, _actions.organizationInfoFetch)({
        organaizationInfoId: me === null || me === void 0 ? void 0 : me.organaisationId
      }));
      dispatch((0, _actions.dataMapFieldUser)({
        searchText: "",
        isAnd: true,
        isUnpaged: true,
        dataScopeId: SCOPE_IDENTIFIRE.USERS.DATASCOPEID
      }));
      dispatch((0, _actions.dataMapFieldRecord)({
        searchText: "",
        isAnd: true,
        isUnpaged: true,
        dataScopeId: SCOPE_IDENTIFIRE.RECORDS.DATASCOPEID
      }));
      dispatch((0, _actions.dataMapFieldFund)({
        searchText: "",
        isAnd: true,
        isUnpaged: true,
        dataScopeId: SCOPE_IDENTIFIRE.FUND_DETAILS.DATASCOPEID
      }));
      dispatch((0, _actions.dataMapFieldFundPerformance)({
        searchText: "",
        isAnd: true,
        isUnpaged: true,
        dataScopeId: SCOPE_IDENTIFIRE.FY_PERFORMANCE.DATASCOPEID
      }));
      dispatch((0, _actions.dataMapFieldFundDonors)({
        searchText: "",
        isAnd: true,
        isUnpaged: true,
        dataScopeId: SCOPE_IDENTIFIRE.FY_DONORS.DATASCOPEID
      }));
      dispatch((0, _actions.dataMapFieldFundImpact)({
        searchText: "",
        isAnd: true,
        isUnpaged: true,
        dataScopeId: SCOPE_IDENTIFIRE.FY_IMPACT.DATASCOPEID
      }));
    }
  }, [getStoreData, me]);
  (0, _react.useEffect)(function () {
    if (orgInfo !== null && orgInfo !== void 0 && orgInfo.data) {
      var _orgInfo$data, _orgInfo$data2;
      surveyStoreSettingsSave((orgInfo === null || orgInfo === void 0 ? void 0 : (_orgInfo$data = orgInfo.data) === null || _orgInfo$data === void 0 ? void 0 : _orgInfo$data.colIsDataMapLocalizationEnabled) === undefined ? true : orgInfo === null || orgInfo === void 0 ? void 0 : (_orgInfo$data2 = orgInfo.data) === null || _orgInfo$data2 === void 0 ? void 0 : _orgInfo$data2.colIsDataMapLocalizationEnabled);
    }
  }, [orgInfo]);
  (0, _react.useEffect)(function () {
    var _fieldUser$content;
    if ((fieldUser === null || fieldUser === void 0 ? void 0 : (_fieldUser$content = fieldUser.content) === null || _fieldUser$content === void 0 ? void 0 : _fieldUser$content.length) > 0) {
      surveyStoreInit(fieldUser === null || fieldUser === void 0 ? void 0 : fieldUser.content);
    }
  }, [fieldUser]);
  (0, _react.useEffect)(function () {
    var _fieldRecord$content;
    if ((fieldRecord === null || fieldRecord === void 0 ? void 0 : (_fieldRecord$content = fieldRecord.content) === null || _fieldRecord$content === void 0 ? void 0 : _fieldRecord$content.length) > 0) {
      surveyStoreInit(fieldRecord === null || fieldRecord === void 0 ? void 0 : fieldRecord.content);
    }
  }, [fieldRecord]);
  (0, _react.useEffect)(function () {
    var _fieldFund$content;
    if ((fieldFund === null || fieldFund === void 0 ? void 0 : (_fieldFund$content = fieldFund.content) === null || _fieldFund$content === void 0 ? void 0 : _fieldFund$content.length) > 0) {
      surveyStoreInit(fieldFund === null || fieldFund === void 0 ? void 0 : fieldFund.content);
    }
  }, [fieldFund]);
  (0, _react.useEffect)(function () {
    var _fieldPerformance$con;
    if ((fieldPerformance === null || fieldPerformance === void 0 ? void 0 : (_fieldPerformance$con = fieldPerformance.content) === null || _fieldPerformance$con === void 0 ? void 0 : _fieldPerformance$con.length) > 0) {
      surveyStoreInit(fieldPerformance === null || fieldPerformance === void 0 ? void 0 : fieldPerformance.content);
    }
  }, [fieldPerformance]);
  (0, _react.useEffect)(function () {
    var _fieldDonor$content;
    if ((fieldDonor === null || fieldDonor === void 0 ? void 0 : (_fieldDonor$content = fieldDonor.content) === null || _fieldDonor$content === void 0 ? void 0 : _fieldDonor$content.length) > 0) {
      surveyStoreInit(fieldDonor === null || fieldDonor === void 0 ? void 0 : fieldDonor.content);
    }
  }, [fieldDonor]);
  (0, _react.useEffect)(function () {
    var _fieldImpact$content;
    if ((fieldImpact === null || fieldImpact === void 0 ? void 0 : (_fieldImpact$content = fieldImpact.content) === null || _fieldImpact$content === void 0 ? void 0 : _fieldImpact$content.length) > 0) {
      surveyStoreInit(fieldImpact === null || fieldImpact === void 0 ? void 0 : fieldImpact.content);
    }
  }, [fieldImpact]);
  return /*#__PURE__*/_react.default.createElement(DataMapLocalizationContext.Provider, {
    value: {
      SCOPE_IDENTIFIRE: SCOPE_IDENTIFIRE,
      surveyStoreSettingsSave: surveyStoreSettingsSave,
      surveyStoreUpdate: surveyStoreUpdate,
      surveyStoreClear: surveyStoreClear,
      renderCustomLabel: renderCustomLabel
    }
  }, props === null || props === void 0 ? void 0 : props.children);
}
function useLocalization() {
  var context = (0, _react.useContext)(DataMapLocalizationContext);
  if (context === undefined) {
    throw new Error("useLocalization must be used within a DataMapLocalizationProvider");
  }
  return context;
}